import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {

  constructor() { }
  ProfileID:any;  

  copyProfileId(profileId,event){   
    const num = new Set([ ".",",","0","1","2","3","4","5","6","7","8","9" ]);
    profileId = profileId.split("").filter(char => num.has(char)).join("");
    const el = document.createElement('textarea');
    el.value = profileId;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    event.stopPropagation();
  }

  trackingActions(data) {
    const caste = `${ data.caste.length > 0 ? `Caste: ${data.caste[0].name}, ` : `` }`;
    const gender = `${ data.gender == 1 ? `Gender: Male, ` : data.gender == 2 ? `Gender: Female, ` : `Gender: Both, `}`;
    const kmpl = `${ data.kmpl != "" && data.kmpl != null ? `KMPLID: ${data.kmpl}, ` : ``}`;
    const name = `${ data.name != "" && data.name != null ? `Name: ${data.name}, ` : ``}`;
    const surname = `${ data.surname != "" && data.surname != null ? `Surname: ${data.surname}, ` : ``}`;
    const profileID = `${ data.profileID != "" && data.profileID != null ? `ProfileID: ${data.profileID}, ` : ``}`;
    const payment = `${ data.paymnet == '1' ? `Paymnet: Paid, ` : data.paymnet == '3' ? `Paymnet: Both, ` : data.paymnet == '0' ? `paymnet: Unpaid, ` : data.paymnet == '' ? `` : ``}`;
    const selectStatus = `${ data.selectedStatus.length > 0 ? `Status: ${String(data.selectedStatus)}` : `` }`
    const trackingTxt = `${data['empName']} searched for ${caste}${gender}${kmpl}${name}${surname}${profileID}${payment}${selectStatus}`;
    return trackingTxt;
  }
}
